module.exports = __webpack_public_path__ + "/images/cover-onboading-guest-screenshot@2x.a436a3d.png";